export default __webpack_public_path__ + "static/media/guardian ticket pass.b5fb4599.png";